import React, { useState, useEffect, useRef } from "react";

import { api } from "./pureFunctions";
import "./styles/projektstatus.css";

import { header, host } from "./globalVariables";
import Nutzergrafik from "./Nutzergrafik";
import { getStaticData, parseOODate } from "./pureFunctions";
import NutzergrafikEinkauf from "./NutzergrafikEinkauf";
import NutzerauswertungsOptionen from "./NutzerauswertungOptionen";
import KarteObjekte from "./KarteObjekte";
import NutzerauswertungZweiKarten from "./NutzerauswertungZweiKarten";
import { getAppointmentsWithLocations } from "./networkFunctions";
import { useConfig } from "./ConfigContext";
import NutzergrafikProvision from "./NutzergrafikProvision";
import NutzergrafikV2 from "./NutzergrafikAktuell";
import { Button } from "react-bootstrap";
import NutzergrafikProvisionH from "./NutzergrafikProvisionH";
import NutzergrafikV2H from "./NutzergrafikAktuellH";
import NutzergrafikProvisionHSum from "./NutzergrafikProvisionHSum";

const initOptionen = [
   "Einkaufstermine (vergangen)",
   "Einkaufstermine (offen)",
   "In Bewertung",
   "In Vorlauf",
   "Im Verkauf",
   "In Abwicklung",
   "Auswertung Vergleich Verkaufte Objekte",
];

export default function Nutzerauswertung({}) {
   const config = useConfig();
   const [availableUsers, setAvailableUsers] = useState();
   const [currentGroup, setCurrentGroup] = useState();
   const [center, setCenter] = useState();
   const [centerPin, setCenterPin] = useState();
   // const [currentT, setCurrentTime]=useState(new Date())
   const [thisMonth, setThisMonth] = useState(() => {
      let heute = new Date();
      heute.setDate(1);
      return heute;
   });
   const [nextMonth, setNextMonth] = useState(() => {
      let heute = new Date();
      heute.setMonth(heute.getMonth() + 1);
      heute.setDate(1);
      return heute;
   });
   const [selectedUser, setSelectedUser] = useState();
   const [loading, setLoading] = useState(false);
   const [objectAbwicklungen, setObjectAbwicklungen] = useState();
   const [estates, setEstates] = useState({});
   const [bewertungen, setBewertungen] = useState();
   const [einkaufstermine, setEinkaufstermine] = useState([]);
   const [einkaufLocationstermine, setEinkaufLocationstermine] = useState([]);
   const [users, setUsers] = useState();
   const [timeLimits, setTimeLimits] = useState(() => {
      const oldOptions = JSON.parse(localStorage.getItem("nutzerauswertungTimelimits"));
      return false ? oldOptions : { start: new Date(), end: new Date(new Date().getTime() + 86400000) };
   });

   const [benutzerOptionen, setBenutzerOptionen] = useState(() => {
      const oldOptions = JSON.parse(localStorage.getItem("nutzerauswertungUserOpt"));
      return false ? oldOptions : {};
   });

   async function getEstates(newBenutzerOptionen, category, categoryDateField) {
      let parameters = {
         ...structuredClone(config.nutzerAuswertung.requestParams[category]),
         listlimit: 500,
         listoffset: 0,
         sortby: { objektnr_extern: "DESC" },
      };

      if (categoryDateField) {
         parameters.filter[categoryDateField] = [
            {
               op: "BETWEEN",
               val: parseOODate(
                  new Date("01.01." + new Date().getFullYear()),
                  new Date("12.31." + new Date().getFullYear()),
               ),
            },
         ];
      }

      if (newBenutzerOptionen && Object.keys(newBenutzerOptionen).length) {
         parameters.filter.benutzer = [{ op: "IN", val: Object.keys(newBenutzerOptionen).map((item) => item) }];
      }

      return await api.post("/api/readEstates", { parameters }, header).then((data) => {
         console.log(data.data);
         return data.data;
      });
   }

   async function getUserCalendar(myUsers, datespan) {
      let timeLimit = parseOODate(datespan.start, datespan.end);

      let parameters = {
         data: ["id", "type", "subject", "status", "date", "location", "users", "contacts", "estate"],
         filter: {
            startDate: timeLimit[0],
            endDate: timeLimit[1],
            // isDone: false,
            isCancelled: false,
            userIds: myUsers,
         },
         listlimit: 500,
         listoffset: 0,
      };

      let [terminResponse, fullDataTermin, newAvailableUsers] = await getAppointmentsWithLocations(parameters);


      return terminResponse;
   }

   async function getEinkaufstermine(newBenutzerOptionen) {
      let timeLimit = parseOODate(timeLimits.start, timeLimits.end);

      let parameters = {
         data: ["id", "type", "subject", "status", "date", "location", "users", "contacts", "estate"],
         filter: {
            startDate: timeLimit[0],
            endDate: timeLimit[1],
            // isDone: false,
            isCancelled: false,
            type: [{ op: "IN", val: Object.keys(config.nutzerAuswertung.terminArten) }],
         },
         listlimit: 500,
         listoffset: 0,
      };
      if (newBenutzerOptionen && Object.keys(newBenutzerOptionen).length) {
         parameters.filter.userIds = Object.keys(newBenutzerOptionen).map((item) => item);
      }

      let [terminResponse, fullDataTermin, newAvailableUsers] = await getAppointmentsWithLocations(parameters);


      setEinkaufLocationstermine(fullDataTermin);
   }

   async function getData(newBenutzerOptionen = benutzerOptionen) {
      let params = new URLSearchParams(document.location.search);
      const url_lat = params.get("lat");
      const url_lon = params.get("lon");
      if (url_lat && url_lon) {
         setCenter([url_lat, url_lon]);
         setCenterPin([url_lat, url_lon]);
      }

      let [newestatekacheln, cleanUserData, newfieldConfiguration] = await getStaticData();

      console.log(cleanUserData);

      setUsers(cleanUserData.userObject);

      const currentEstates = await getEstates(newBenutzerOptionen, "current"); // getCurrentEstates(newBenutzerOptionen);
      const soldEstates = await getEstates(newBenutzerOptionen, "sold", "verkauft_am");
      const lostEstates = await getEstates(newBenutzerOptionen, "lost", config.estate.Gescheitert_am); //await getFailedEstates(newBenutzerOptionen);
      let avUsers = [...currentEstates, ...soldEstates, ...lostEstates].reduce((oldObj, item) => {
         return { ...oldObj, [item.elements.benutzer]: false };
      }, {});
console.log(avUsers);

      setAvailableUsers(avUsers);
      setEstates({
         aktiv: currentEstates.map((item) => ({ ...item.elements, id: item.id, myStatus: "aktiv" })),
         verkauft: soldEstates.map((item) => ({ ...item.elements, id: item.id, myStatus: "verkauft" })),
         gescheitert: lostEstates.map((item) => ({ ...item.elements, id: item.id, myStatus: "gescheitert" })),
      });

      await getEinkaufstermine(newBenutzerOptionen);
   }

   useEffect(() => {
      setLoading(true);
      getData();

      setLoading(false);
   }, []);

   return (
      <>
         <title>Objektverteilung</title>
         <div className="text-center mt-3 mb-2">
            {Object.keys(config.standorte)
               .filter((item) => item !== "center")
               .map((item) => {
                  return (
                     <Button
                        variant={item === currentGroup ? "dark" : "outline-dark"}
                        onClick={() => {
                           let updatedBenutzerOptionen;
                           if (item === currentGroup) {
                              updatedBenutzerOptionen = {};
                              setCenterPin(false);
                              setCurrentGroup();
                           } else {
                              updatedBenutzerOptionen = Object.fromEntries(
                                 config.standorte[item].sales.map((id) => [id, true]),
                              );

                              setCurrentGroup(item);
                              setCenterPin(config.standorte[item].coords);
                           }
                           setBenutzerOptionen(updatedBenutzerOptionen);
                           getData(updatedBenutzerOptionen);
                        }}
                        className="me-1 mb-1"
                     >
                        {item}
                     </Button>
                  );
               })}
         </div>

         <NutzerauswertungsOptionen
            initOptionen={initOptionen}
            userObjects={users}
            benutzerOptionen={benutzerOptionen}
            setBenutzerOptionen={setBenutzerOptionen}
            timeLimits={timeLimits}
            setTimeLimits={setTimeLimits}
            getData={getData}
            initialshow={false}
            placement={"start"} //'start', 'end', 'top', 'bottom'
         />
         <div className="projektstatus p-0">
            <div className="projektstatus-l1">
               <div className="">
                  {estates.aktiv && (
                     <NutzerauswertungZweiKarten
                        center={center}
                        setCenter={setCenter}
                        centerPin={centerPin}
                        estates={estates.aktiv}
                        userObjects={users}
                        selectedUser={selectedUser}
                        setSelectedUser={setSelectedUser}
                        terminInfos={einkaufLocationstermine}
                        terminArten={config.nutzerAuswertung.terminArten}
                        getUserCalendar={getUserCalendar}
                     />
                  )}

                  <div
                     className="projektstatus-l2 projektstatus-statistik flex-row"
                     style={{
                        height: "1200px",
                        overflow: "auto",
                        position: "relative",
                     }}
                  >
                     {!loading && estates.aktiv && (
                        <NutzergrafikV2H
                           heading={"Aktuelle Objekte pro Betreuer und Status (insg. " + estates.aktiv.length + ")"}
                           users={users}
                           availableUsers={availableUsers}
                           estates={estates.aktiv}
                           selectedUser={selectedUser}
                           setSelectedUser={setSelectedUser}
                           statConfig={config.stats.vk}
                        />
                     )}
                     {!loading && estates && (
                        <NutzergrafikProvisionH
                           users={users}
                           availableUsers={availableUsers}
                           estates={Object.values(estates).flat()}
                           selectedUser={selectedUser}
                           setSelectedUser={setSelectedUser}
                           statConfig={config.stats.vk}
                        />
                     )}
                     {!loading && estates && (
                        <NutzergrafikProvisionHSum
                           users={users}
                           availableUsers={availableUsers}
                           estates={Object.values(estates).flat()}
                           selectedUser={selectedUser}
                           setSelectedUser={setSelectedUser}
                           statConfig={config.stats.vk}
                        />
                     )}
                  </div>
               </div>
            </div>
         </div>
      </>
   );
}
